import React, { useEffect, useState } from "react";
import { ISidebarForChannelProps } from "./ISidebarForChannelProps";

import "./SidebarForChannelComponent.scss";
import "./sidebarforchannel-responsive.scss";
import miscUtils from "../../../utils/miscUtils";
import { push } from "connected-react-router";
import { globalActions } from "../../../store/actions";
import { Map } from "immutable";

import { withRouter } from "react-router";
import { connect } from "react-redux";
import { GroupService } from "../../../api/services/groups";
import { ChannelService } from "../../../api/services/channels";
import { CloseIcon } from "../../../constants/icons";
import GlobeIcon from "components/sidebar/newIcons/Globe";
import Collapse from "rc-collapse";
import "rc-collapse/assets/index.css";
import Modal from "elements/modal/Modal";
import ShareGroup from "components/shareGroup";
import { Link } from "react-router-dom";
import { Emoji } from "emoji-mart";
import { AccessLevels } from "containers/channels/channelDetails/domain";
import LibraryIcon from 'components/sidebar/newIcons/Library';
import CalenderIcon from 'components/sidebar/newIcons/Calender';
import HomeIcon from 'components/sidebar/newIcons/Home';
import FeedIcon from 'components/sidebar/newIcons/Feed';
import CourseIcon from 'components/sidebar/newIcons/Course';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { getChannelCollections, getUnAssignedChannels } from "../domain";
// import { ReactComponent as PlusCircleIcon } from '../icons/plus-circle.svg';
import ChannelHashTag from "../newIcons/ChannelHashTag";
import { setlocalStorageValue } from "utils/localStorage";
import InvitePlusIcon from "components/sidebar/newIcons/InvitePlusIcon";
import { AppContext } from "containers/main/MainComponent";
import { useHistory } from 'react-router'

const SidebarForChannelComponent: React.FC<ISidebarForChannelProps> = (
  props: any
) => {
  const {
    closeHamburgerMenu,
    // @ts-ignore
    global: { currentView, theme },
    subdomain,
  } = props;

    const { groupChannels, setGroupChannels } =  React.useContext(AppContext);
  
  const [selectedChannel, selectChannel] = useState<number>(-1);
  const [selectedGroup, selectGroup] = useState<any>(-1);
  // const [postsSearchQuery, setPostsSearchQuery] = useState<string>("");
  const [chosenChannel, setChosenChannel] = useState<any>();
  // const [visibleOpen, setVisibleOpen] = useState<number>(0);
  // const [visiblePrivate, setVisiblePrivate] = useState<number>(0);
  // const [visiblePaid, setVisiblePaid] = useState<number>(0);
  // const [visiblePlan, setVisiblePlan] = useState<number>(0);
  const [isModalOpen, setToggleModal] = useState<boolean>(false);
  // const [showEvents, setShowEvents] = React.useState<any>(false);
  // const [openChannelsActive, setOpenChannelsActive] = useState<boolean>(true);
  // const [inviteChannelsActive, setInviteChannelsActive] = useState<boolean>(true);
  // const [paidChannelsActive, setPaidChannelsActive] = useState<boolean>(true);
  const [channelCollections, setChannelCollections] = useState<Array<any>>([]);
  const [unAssignedChannels, setUnAssignedChannels] = useState<Array<any>>([]);
  const [unAssignedChannelsActive, setUnAssignedChannelsActive] = useState<boolean>(true);
  const [shouldShowHomePage, setShouldShowHomePage] = useState<boolean>(false);
  const history = useHistory();

  useEffect(() => {
    if (
      props.group &&
      props.group.home_page_config &&
      props.group.home_page_config.status &&
      (
        showAnnouncementHomeSection() ||
        showNewMemberHomeSection() ||
        showUpcomingEventsHomeSection() ||
        showSuggestedContentHomeSection() ||
        showUserCoursesHomeSection() 
        // showHomeFeed()
      )
    ) {
      setShouldShowHomePage(true);
    }
  }, [props.group, props.customizedPostsData, props.homePageConfigDetails, props.userCourses]);

  useEffect(() => {
    if (groupChannels && groupChannels.length > 0) {
      if (channelCollections.length === 0) {
        setChannelCollections(getChannelCollections(groupChannels));
      }
      if (unAssignedChannels.length === 0) {
        setUnAssignedChannels(getUnAssignedChannels(groupChannels));
      }
    }
  }, [groupChannels]);

  useEffect(() => {
    if (subdomain) {
      const groupData: any = miscUtils.getGroupSlugChannel(subdomain);

      switchToGroup(subdomain || groupData.slug, groupData.channel);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subdomain]);

  useEffect(() => {
    if (window.innerWidth < 992) {
      setlocalStorageValue("sidebar", false);
    }

    if (props.location.pathname.split("/").includes("posts")) {
      selectChannel(props.currentChannel);
    }
  }, [props.location.pathname, props.currentChannel]);

  useEffect(() => {
    if (groupChannels) {
      checkNumberOfChannels("open");
      checkNumberOfChannels("private");
      checkNumberOfChannels("paid");
      checkNumberOfChannels(AccessLevels.Plan);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupChannels]);

  const showAnnouncementHomeSection = () => {
    return (
      props.group.home_page_config &&
      props.group.home_page_config.status &&
      props.group.home_page_config.announcement &&
      props.homePageConfigDetails &&
      props.homePageConfigDetails.announcement
    )
  }

  const showNewMemberHomeSection = () => {
    return (
      props.group.home_page_config &&
      props.group.home_page_config.status &&
      props.group.home_page_config.new_members &&
      props.homePageConfigDetails &&
      props.homePageConfigDetails.new_members &&
      props.homePageConfigDetails.new_members.filter((member: any) => !!member).length > 0
    )
  }

  const showSuggestedContentHomeSection = () => {
    return (
      props.group.home_page_config &&
      props.group.home_page_config.status &&
      props.group.home_page_config.library_contents &&
      props.homePageConfigDetails &&
      props.homePageConfigDetails.library_contents &&
      props.homePageConfigDetails.library_contents.filter((content: any) => content.contentable).length > 0
    )
  }

  const showUpcomingEventsHomeSection = () => {
    return (
      props.group.home_page_config &&
      props.group.home_page_config.status &&
      props.group.home_page_config.upcoming_events &&
      props.homePageConfigDetails &&
      props.homePageConfigDetails.upcoming_events &&
      props.homePageConfigDetails.upcoming_events.filter((event: any) => !!event).length > 0
    )
  }

  const showUserCoursesHomeSection = () => {
    return (
      props.userCourses &&
      props.userCourses.data &&
      props.userCourses.data.length
    )
  }

  // const showHomeFeed = () => {
  //   return (
  //     props.customizedPostsData &&
  //     props.customizedPostsData.data &&
  //     props.customizedPostsData.data.length
  //   )
  // }

  function checkNumberOfChannels(query: any) {
    // let count = 0;
    // if (groupChannels) {
    //   groupChannels.map((channel: any) => {
    //     if (channel.status === query && channel.status !== "archived") {
    //       count += 1;
    //     }
    //     return null;
    //   });
    // }
    // if (query === "open") {
    //   setVisibleOpen(count);
    // }
    // if (query === "private") {
    //   setVisiblePrivate(count);
    // }
    // if (query === "paid") {
    //   setVisiblePaid(count);
    // }
    // if (query === AccessLevels.Plan) {
    //   setVisiblePlan(count)
    // }
  }

  function openModal() {
    setToggleModal(true);
  }

  function closeModal() {
    setToggleModal(false);
  }

  function viewChannel(channelId: number) {
    if (window.innerWidth < 992) {
      closeHamburgerMenu();
    }
    
    setChosenChannel(channelId);
    selectChannel(channelId);
    props.goToChannel(selectedGroup, channelId, props.isSubdomain);
  }

  const determineChosenChannel = (): string | null => {
    const urlLastPart: string = window.location.pathname.split("/").pop() as string;
    if (urlLastPart) {
      return urlLastPart;
    }

    return null;
  }

  function switchToGroup(groupSlug: string, channelId?: number) {
    GroupService.getInstance()
      .getGroup(subdomain || groupSlug)
      .then((groupData: any) => {
        if (groupData && groupData.id) {
          ChannelService.getInstance()
            .getGroupChannels(groupData.id)
            .then((channels: any) => {
              setGroupChannels(channels.data);
              selectGroup(subdomain || groupData.slug);
              selectChannel(
                chosenChannel ? chosenChannel : determineChosenChannel()
              );
            });
        }
      }).catch((error: any) => {
        console.error(error)
        new Error(error)
      })
  }

  function changeGroupInviteLink() {
    if (props.group) {
      GroupService.getInstance()
        .changeGroupInviteLink(props.group.id)
        .then(() => { })
        .catch((error: any) => {
          console.error(error)
          new Error(error)
        })
    }
  }

  function setChannelToActive(selectedChannel: any, channel: any) {
    return selectedChannel === channel.slug &&
      !(
        props.group &&
        props.group.home_page_config &&
        props.group.home_page_config.status &&
        props.group.default_channel &&
        props.group.default_channel.slug === selectedChannel &&
        window.location.pathname === "/"
      ) &&
      !window.location.pathname.split("/").includes("library") &&
      !window.location.pathname.split("/").includes("members") &&
      !window.location.pathname.split("/").includes("courses")
      ? "channel-link active"
      : "channel-link";
  }

  function getHomeLinkStyle() {
    if (theme && theme.custom && theme.custom.primaryColor && ((window.location.pathname === "/home") && !showCommunityLandingPage())) {
      const rgbCommunityColor: any = miscUtils.hexToRgb(theme.custom.primaryColor);

      return {
        color: theme.custom.fontColor,
        backgroundColor: rgbCommunityColor ? `rgba(${rgbCommunityColor.r}, ${rgbCommunityColor.g}, ${rgbCommunityColor.b}, .1)` : '',
      }
    }
    return {}
  }

  function getFeedLinkStyle() {
    if (theme && theme.custom && theme.custom.primaryColor && window.location.pathname === "/feed") {
      const rgbCommunityColor: any = miscUtils.hexToRgb(theme.custom.primaryColor);

      return {
        color: theme.custom.fontColor,
        backgroundColor: rgbCommunityColor ? `rgba(${rgbCommunityColor.r}, ${rgbCommunityColor.g}, ${rgbCommunityColor.b}, .1)` : '',
      }
    }
    return {}
  }

  function getLibraryLinkStyles(url: string) {
    if (theme && theme.custom && theme.custom.primaryColor && window.location.pathname.split("/").includes(url)) {
      const rgbCommunityColor: any = miscUtils.hexToRgb(theme.custom.primaryColor);

      return {
        color: theme.custom.fontColor,
        backgroundColor: rgbCommunityColor ? `rgba(${rgbCommunityColor.r}, ${rgbCommunityColor.g}, ${rgbCommunityColor.b}, .1)` : '',
      }
    }
    return {}
  }

  function getEventsLinkStyle() {
    if (theme && theme.custom && theme.custom.primaryColor && window.location.pathname.split("/").includes("events")) {
      const rgbCommunityColor: any = miscUtils.hexToRgb(theme.custom.primaryColor);

      return {
        color: theme.custom.fontColor,
        backgroundColor: rgbCommunityColor ? `rgba(${rgbCommunityColor.r}, ${rgbCommunityColor.g}, ${rgbCommunityColor.b}, .1)` : '',
      }
    }
    return {}
  }

  const getDisplayedUnreadPosts = (count: number) => {
    if (count <= 9) {
      return `${count}`
    }

    return '9+'
  }

  const readChannelPosts = (channelId: any) => {
    ChannelService.getInstance()
      .readChannelPosts(channelId)
      .then(() => { })
      .catch(() => { });
  }

  const clearChannelPostCount = (channelId: any, channelIndex: any, collectionIndex?: any) => {
    if (collectionIndex || collectionIndex === 0) {
      if (channelCollections[collectionIndex].channels[channelIndex].unread_post_count > 0) {
        const channelCollectionsCopy: any = JSON.parse(JSON.stringify(channelCollections));

        channelCollectionsCopy[collectionIndex].channels[channelIndex] = {
          ...channelCollectionsCopy[collectionIndex].channels[channelIndex],
          unread_post_count: 0,
        }

        setChannelCollections([...channelCollectionsCopy]);

        readChannelPosts(channelId);
      }
    } else {
      if (unAssignedChannels[channelIndex] && unAssignedChannels[channelIndex].unread_post_count > 0) {
        const unAssignedChannelsCopy: any = JSON.parse(JSON.stringify(unAssignedChannels));

        unAssignedChannelsCopy[channelIndex] = {
          ...unAssignedChannelsCopy[channelIndex],
          unread_post_count: 0,
        }

        setUnAssignedChannels([...unAssignedChannelsCopy]);

        readChannelPosts(channelId);
      }
    }
  }

  const [linksActive, setlinksActive] = useState<boolean>(true);
  const themeIconColor = theme &&
    theme.custom &&
    theme.custom.primaryColor !== '#ffffff' &&
    theme.custom.primaryColor
  const { group } = props
  const shouldShowMenuText = (
    (group && group.menu['courses']['show']) ||
    (group && group.menu['library']['show']) ||
    (group && group.menu['events']['show']) ||
    (group && group.menu['people']['show'] && group.user_membership && miscUtils.isActiveCommunityMember(group.user_membership)) ||
    group && group.menu['invite']['show'] ||
    shouldShowHomePage
  )

  const showCommunityLandingPage = () => {
    return (
      ((
        (props.group && props.group.user_membership === null) ||
        miscUtils.isMembershipPendingApproval(props.group && props.group.user_membership)
      ) || (!props.uid)) &&
      window.location.pathname === "/"
    )
  }

    const userPlanIsInAuthorizedPlans = (channelData: any): boolean => {
      if (
        !props.group.user_membership ||
        !props.group.user_membership.active_subscription
      ) {
        return false;
      }
      let planIsAuthorized: boolean = false;
      channelData.authorized_plans.forEach((plan: any) => {
        if (plan.id === props.group.user_membership.active_subscription.plan.id) {
          planIsAuthorized = true;
        }
      })
      return planIsAuthorized;
    }
    const redirectToLink = (channelData: any) => {
      const FREE_PLAN_PRICE: number = 0;
  
      if (
        props.group &&
        channelData &&
        channelData.lock_screen_active &&
        channelData.lock_screen_type === 'redirect'
      ) {
  
        // channel is by plan
        if (
          props.group.user_membership &&
          !miscUtils.isAdmin(props.group.user_membership) &&
          channelData.status === AccessLevels.Plan &&
          !userPlanIsInAuthorizedPlans(channelData) &&
          !miscUtils.isChannelMember(props.group.user_membership, channelData)
        ) {
          return channelData.lock_screen_default_url
        }
  
        // channel is by segment
        if (
          props.group.user_membership &&
          !miscUtils.isAdmin(props.group.user_membership) &&
          (channelData.status === AccessLevels.Segment) &&
          channelData.authorized_segments &&
          !miscUtils.userIsOnResourseSegment(props.group.user_membership, channelData.authorized_segments) &&
          !miscUtils.isChannelMember(props.group.user_membership, channelData)
        ) {
          return channelData.lock_screen_default_url
  
        }
  
        // channel is private
        if (
          (channelData.status === AccessLevels.Private) &&
          !miscUtils.isAdmin(props.group.user_membership) &&
          !miscUtils.isChannelMember(props.group.user_membership, channelData)
        ) {
          return channelData.lock_screen_default_url
  
        }
  
        // channel by paid members
        if (
          (channelData.status === AccessLevels.Paid) &&
          !miscUtils.isAdmin(props.group.user_membership) &&
          !miscUtils.isChannelMember(props.group.user_membership, channelData) &&
          miscUtils.isActiveCommunityMember(props.group && props.group.user_membership) &&
          props.group.user_membership &&
          props.group.user_membership.active_subscription &&
          props.group.user_membership.active_subscription.plan.price === FREE_PLAN_PRICE
        ) {
          return channelData.lock_screen_default_url
  
        }
  
        // logged out user
        if (!props.uid) {
          return channelData.lock_screen_default_url
  
        }
  
      }
      else {
        return null
      }
    }

  return (
    <>
      {document.location.pathname !== "/login" && document.location.pathname !== "/signin" && document.location.pathname.split("/").pop() !== 'purchase' && (
        <div className={`sidebar-channel-only__wrap sub-nav`}>
          <div className="sidebar__content-channels-list">
            <PerfectScrollbar
              className="sidebar-logout-scroll-area"
              options={{ wheelPropagation: false }}
            >
              <>
                <div className="joined-channels">
                  <div className={`joined-channels-side-bar sidebar-actions`}>
                    {
                      shouldShowMenuText &&
                      <h1 className="sidebar-actions-menu-text">Menu</h1>
                    }
                    {
                      shouldShowHomePage && (
                        <Link
                          style={getHomeLinkStyle()}
                          onClick={() => {
                            selectChannel(-1);
                            closeHamburgerMenu();
                            window.scrollTo({
                              top: 0,
                              behavior: 'auto',
                            });
                          }}
                          className={`action ${((window.location.pathname === "/home") && !showCommunityLandingPage()) && "active-courses"}`}
                          to={
                            // showCommunityLandingPage() ?
                            subdomain ?
                            `/home` :
                            `/group/${props.group && props.group.slug}/home` 
                            // subdomain
                            //   ? `/`
                            //   : `/group/${props.group && props.group.slug}/`
                          }
                        >
                               <div className="sidebar-icons-container">
                          <HomeIcon
                            strokeColor={
                              themeIconColor !== null && ((window.location.pathname === "/home") && !showCommunityLandingPage())
                                ?
                                themeIconColor
                                :
                                themeIconColor === null && ((window.location.pathname === "/home") && !showCommunityLandingPage())
                                  ?
                                  '#767A8A'
                                  :
                                  undefined
                            }
                          />
                          </div>
                          Home
                        </Link>)}
                    {props.group && props.group.menu['feed']['show'] && (
                        <Link
                          style={getFeedLinkStyle()}
                          onClick={() => {
                            selectChannel(-1);
                            closeHamburgerMenu();
                            window.scrollTo({
                              top: 0,
                              behavior: 'auto',
                            });
                          }}
                          className={`action ${window.location.pathname === "/feed" && "active-courses"}`}
                          to={
                            subdomain
                              ? `/feed`
                              : `/group/${props.group && props.group.slug}/feed`
                          }
                        >
                               <div className="sidebar-icons-container">
                          <FeedIcon
                          strokeColor={theme && theme.custom && window.location.pathname === "/feed" && theme.custom.primaryColor}
                          />
                          </div>
                        Feed
                        </Link>)}

                    {props.group && props.group.menu['courses']['show'] ? (
                      <Link
                        style={getLibraryLinkStyles("courses")}
                        onClick={() => {
                          selectChannel(-1);
                          closeHamburgerMenu();
                          window.scrollTo({
                            top: 0,
                            behavior: 'auto',
                          });
                        }}
                        className={`action ${window.location.pathname.includes(
                          "/courses"
                        ) && "active-courses"}`}
                        to="/courses"
                      >
                               <div className="sidebar-icons-container">
                        <CourseIcon
                          strokeColor={
                            themeIconColor !== null && window.location.pathname.split("/").includes("courses")
                              ?
                              themeIconColor
                              :
                              themeIconColor === null && window.location.pathname.split("/").includes("courses")
                                ?
                                '#767A8A'
                                :
                                undefined
                          }
                        />
                        </div>
                        Courses
                      </Link>
                    ) : (<></>)}
                    {props.group && props.group.menu['library']['show'] ? (
                      <Link
                        style={getLibraryLinkStyles("library")}
                        onClick={() => {
                          selectChannel(-1);
                          closeHamburgerMenu();
                          window.scrollTo({
                            top: 0,
                            behavior: 'auto',
                          });
                        }}
                        className={`action ${window.location.pathname.split("/").includes(
                          "library"
                        ) && "active-courses"}`}
                        to="/library"
                      >
                               <div className="sidebar-icons-container">
                        <LibraryIcon
                          strokeColor={theme && theme.custom && window.location.pathname.includes("/library") && theme.custom.primaryColor}
                        />
                        </div>
                        Library
                      </Link>
                    ) : (<></>)}
                    {props.group && props.group.menu['events']['show'] ? (
                      <Link
                        style={getEventsLinkStyle()}
                        className={`action ${window.location.pathname.split("/").includes("events") && "active-courses"}`}
                        to={
                          "/events"
                        }
                        onClick={() => {
                          window.scrollTo({
                            top: 0,
                            behavior: 'auto',
                          });
                          closeHamburgerMenu();
                        }}
                      >
                               <div className="sidebar-icons-container">
                        <CalenderIcon
                          strokeColor={theme && theme.custom && window.location.pathname.split("/").includes("events") && theme.custom.primaryColor}
                        />
                        </div>
                        Events
                      </Link>
                    ) : <></>}


                          {group && group.menu['invite']['show'] && (
                              <Link
                                className={`action`}
                                to={'#'}
                                onClick={() => openModal()}
                              >
                               <div className="sidebar-icons-container">

                        <InvitePlusIcon
                          strokeColor={'#666'}
                        />
                        </div>
                        Invite members
                        </Link>)}
                      
                  </div>
                  <Modal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    size={"540px"}
                  >
                    <div className="invite--group__header-card">
                      <button
                        type="button"
                        className="close-modal"
                        onClick={closeModal}
                      >
                        <CloseIcon />
                      </button>
                      <ShareGroup
                        theme={theme}
                        usersGroups={false}
                        groupData={props.group}
                        generateNewLink={true}
                        changeLink={changeGroupInviteLink}
                        closeModal={closeModal}
                      />
                    </div>
                  </Modal>
                  <div className="public-joined-channels">
                    {
                      channelCollections.map((collection: any, collectionIndex: any) => (
                        <Collapse
                          accordion={null}
                          className="header-parent"
                          defaultActiveKey={collection.open ? "0" : null}
                          onChange={(key: Array<any>) => setChannelCollections(channelCollections.map((channelCollection: any) => {
                            if (channelCollection.id === collection.id) {
                              return {
                                ...channelCollection,
                                open: key.length > 0,
                              }
                            }

                            return channelCollection;
                          }))}
                          expandIcon={() => <FontAwesomeIcon icon={collection.open ? faChevronDown : faChevronUp} />}
                        >
                          <Collapse.Panel
                            header={miscUtils.truncateString(collection.name, 19)}
                            className="header-item"
                          >
                            <ul>
                              {collection.channels.map((channel: any, channelIndex: any) => (
                                // <Link
                                //   to={`/channel/${channel.slug}`}
                                //   onClick={() => {
                                //     clearChannelPostCount(channel.id, channelIndex);
                                //     viewChannel(channel.slug);
                                //   }}
                                // >
                                  <li
                                    key={channelIndex}
                                    onClick={() => {
                                       if (redirectToLink(channel)) {
                                          window.location.assign(redirectToLink(channel));
                                          return
                                        }
                                        history.push(`/channel/${channel.slug}`);
                                      clearChannelPostCount(channel.id, channelIndex, collectionIndex);
                                      viewChannel(channel.slug);
                                    }
                                    }
                                    style={miscUtils.getChannelLinksColor(props.group, channel, selectedChannel, theme)}
                                    className={setChannelToActive(
                                      selectedChannel,
                                      channel
                                    )}
                                  >
                                    <div 
                                    title={channel.name} 
                                    className="gp-sidebar-channel-container"
                                    >
                                      <div
                                      className="gp-channel-emoji-container"
                                      >
                                        {
                                          channel.emoji ?
                                          <span
                                            className="sidebar-emoji"
                                            dangerouslySetInnerHTML={{
                                              //@ts-ignore
                                              __html: Emoji({
                                                html: true,
                                                set: "apple",
                                                emoji: channel.emoji,
                                                size: 18
                                              })
                                            }}
                                          /> : 
                                          <ChannelHashTag
                                          fill={
                                            theme &&
                                            theme.custom &&
                                            selectedChannel === channel.slug ?
                                            theme.custom.primaryColor : 
                                            channel.unread_post_count ? 
                                            '#000' :
                                            undefined
                                          }
                                          />
                                        }
                                      </div>
                                      <p
                                        className={`gp-sidebar-channel-name ${channel.unread_post_count ? 'gp-sidebar-channel-name--badge' : ''}`}
                                      >
                                        {channel.name}
                                      </p>
                                    </div>
                                    {channel.unread_post_count ? (
                                      <div
                                        className={`items-count-container--channel`}
                                        style={{
                                          backgroundColor: (theme && theme.custom) ? theme.custom.primaryColor : "",
                                        }}
                                      >
                                        {getDisplayedUnreadPosts(channel.unread_post_count)}
                                      </div>
                                    ) : (<></>)}
                                  </li>
                                // </Link>
                              ))}
                            </ul>
                          </Collapse.Panel>
                        </Collapse>
                      ))
                    }
                    {
                      unAssignedChannels.length > 0 &&
                      <Collapse
                        accordion={null}
                        className="header-parent"
                        defaultActiveKey="0"
                          onChange={(key: Array<any>) => setUnAssignedChannelsActive(key.length > 0)}
                          expandIcon={() => <FontAwesomeIcon icon={unAssignedChannelsActive ? faChevronDown : faChevronUp} />}
                        >
                          <Collapse.Panel
                            header="CHANNELS"
                            className="header-item"
                          >
                            <ul>
                              {unAssignedChannels.map((channel: any, channelIndex: any) => (
                                // <Link
                                //   to={`/channel/${channel.slug}`}
                                //   onClick={() => {
                                //     clearChannelPostCount(channel.id, channelIndex);
                                //     viewChannel(channel.slug);
                                //   }}
                                // >
                                  <li
                                  key={channelIndex}
                                  onClick={() => {
                                       if (redirectToLink(channel)) {
                                          window.location.assign(redirectToLink(channel));
                                          return
                                        }
                                        history.push(`/channel/${channel.slug}`);
                                    clearChannelPostCount(channel.id, channelIndex)
                                    viewChannel(channel.slug);
                                  }
                                  }
                                  style={miscUtils.getChannelLinksColor(props.group, channel, selectedChannel, theme)}
                                  className={setChannelToActive(
                                    selectedChannel,
                                    channel
                                  )}
                                >
                                  <div 
                                  title={channel.name} 
                                  className="gp-sidebar-channel-container"
                                  >
                                     <div
                                      className="gp-channel-emoji-container"
                                      >
                                        {
                                          channel.emoji ?
                                          <span
                                            className="sidebar-emoji"
                                            dangerouslySetInnerHTML={{
                                              //@ts-ignore
                                              __html: Emoji({
                                                html: true,
                                                set: "apple",
                                                emoji: channel.emoji,
                                                size: 18
                                              })
                                            }}
                                          /> : 
                                          <ChannelHashTag
                                          fill={
                                            theme &&
                                            theme.custom &&
                                            selectedChannel === channel.slug ?
                                            theme.custom.primaryColor : 
                                            channel.unread_post_count ? 
                                            '#000' :
                                            undefined
                                          }
                                          />
                                        }
                                      </div>
                                    <p
                                        className={`gp-sidebar-channel-name ${channel.unread_post_count ? 'gp-sidebar-channel-name--badge' : ''}`}
                                    >
                                      {channel.name}
                                    </p>
                                  </div>
                                  {channel.unread_post_count ? (
                                      <div
                                        className={`items-count-container--channel`}
                                        style={{
                                          backgroundColor: (theme && theme.custom) ? theme.custom.primaryColor : "",
                                        }}
                                    >
                                      {getDisplayedUnreadPosts(channel.unread_post_count)}
                                    </div>
                                  ) : (<></>)}
                                </li>
                                // </Link>
                              ))}
                          </ul>
                        </Collapse.Panel>
                      </Collapse>
                    }
                  </div>

                  {
                    props.group && props.group.external_links && props.group.external_links && props.group.external_links.length > 0 &&
                    <div className="joined-channels__scroll-area links links-scroll-area">
                      <Collapse
                        accordion={null}
                        className="header-parent"
                        defaultActiveKey="0"
                        onChange={(key: Array<any>) => setlinksActive(key.length > 0)}
                        expandIcon={() => <FontAwesomeIcon icon={linksActive ? faChevronDown : faChevronUp} />}
                      >
                        <Collapse.Panel
                          header="Links"
                          className="header-item"
                        >
                          <ul>
                            {props.group.external_links.map((channel: any, index: any) => (
                              <a
                                href={channel.url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <li
                                  key={index}
                                >
                                  <div
                                    title={channel.label}
                                    className="gp-sidebar-channel-container"
                                  >
                                    <div
                                      className="gp-channel-emoji-container"
                                    >
                                      <GlobeIcon />
                                    </div>
                                    <p className={`gp-sidebar-channel-name`}>
                                      {channel.label}
                                    </p>
                                  </div>

                                </li>
                              </a>
                            ))}
                          </ul>
                        </Collapse.Panel>
                      </Collapse>
                    </div>
                  }
                </div>

              </>
            </PerfectScrollbar>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: any, ownProps: ISidebarForChannelProps) => {
  const global = Map(state.get("global", {})).toJS() as any;
  const groups = Map(state.get("group", {})).toJS() as any;
  const uid: string = state.getIn(["authorize", "uid"]) as string;
  return {
    uid,
    global,
    groups
  };
};

const mapDispatchToProps = (
  dispatch: any,
  ownProps: ISidebarForChannelProps
) => {
  return {
    goToChannel: (
      groupSlug: string,
      channelId: number,
      isSubdomain: boolean
    ) => {
      dispatch(
        push(
          isSubdomain
            ? `/channel/${channelId}`
            : `/channel/${groupSlug}/${channelId}`
        )
      );
    },
    setPostsQuery: (query: string) =>
      dispatch(globalActions.setPostsQuery(query)),
    closeHamburgerMenu: () => dispatch(globalActions.closeHamburgerMenu()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SidebarForChannelComponent as any) as any
) as any;
